import { render, staticRenderFns } from "./SameRegionShippings.vue?vue&type=template&id=0cea18a9"
import script from "./SameRegionShippings.vue?vue&type=script&lang=js"
export * from "./SameRegionShippings.vue?vue&type=script&lang=js"
import style0 from "./SameRegionShippings.vue?vue&type=style&index=0&id=0cea18a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports